export class State {
    public error = '';
    public schedulerInitData = {
        days: 0,
        time: '',
        dApptNotification: true,
        locationIds: [],
        startDate: null,
        endDate: null
    };
    public scheduler = {};
    public schedulers = [];
  }